<template>
  <qx-card title="ETC卡列表">
    <LogRightDialog ref="logRightDialog" busiCode="400003" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1005040101">
        <ImportBtn
          title="导入ETC"
          fileUrl="/file/ETC导入模板.xlsx"
          bizCodes="imp100048"
          :isDownloadLocalTemplate="true"
          :customPost="true"
          @sub="handleImport"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1005040102">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="etcMaintainBO.ajax?cmd=queryEtc"
          :params="fullSearchData"
          bizName="ETC卡数据导出"
          bizCode="exp100035"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="4000504">
        <el-button type="primary" plain @click="toEdit()">新增</el-button>
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'serviceName'"
                  @click="toServiceDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section v-if="scope.column.property === 'etcCardTypeName'">
                  <span>{{
                    scope.row.etcCardTypeName || scope.row.xlCardTypeName
                  }}</span>
                </section>
                <section
                  v-if="
                    scope.column.property !== 'serviceName' &&
                    scope.column.property !== 'etcCardTypeName'
                  "
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '4000506',
                    showCondition: scope.row.paymentType === 1,
                    name: '充值',
                    event: () => toRecharge(scope.row),
                  },
                  {
                    showCondition: scope.row.paymentType === 1,
                    name: '充值记录',
                    event: () => toRechargeRecord(scope.row.etcId),
                  },
                  {
                    permpisions: '4000505',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row.id),
                  },
                  {
                    name: '日志',
                    event: () => showLog(scope.row.id),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
    <RechargeDialog ref="rechargeDialog" @sub="reloadData" />
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  etcManageList,
  etcImport,
} from 'api/service';
import LogRightDialog from 'components/logRightDialog';
import ImportBtn from 'components/importBtn';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import RechargeDialog from './rechargeDialog';
import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ImportBtn,
    ExportBtn,
    TableBtn,
    RechargeDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'etcId', label: 'ETC卡号', fixed: true },
          { prop: 'etcCardTypeName', label: '卡类型' },
          { prop: 'bindVehicle', label: '现绑定车辆' },
          { prop: 'serviceName', label: '服务商' },
          { prop: 'paymentTypeName', label: '付费类型' },
          { prop: 'etcBalance', label: '当前余额' },
          { prop: 'accountPeriodRemark', label: '账期' },
          { prop: 'stateName', label: 'ETC状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: etcManageList,
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + 'ETC',
        url: `/manage/service/etc/manage/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    toServiceDetail (item) {
      this.jump({
        label: '服务商详情',
        url: '/manage/service/merchant/manage/detail?id=' + item.userId,
        full: true,
      });
    },
    toRecharge (item) {
      this.$refs.rechargeDialog.show(item);
    },
    reloadData () {
      this.getData();
    },
    toRechargeRecord (etcId) {
      this.jump({
        label: 'ETC充值记录',
        url: '/manage/service/etc/rechargeRecord?etcCardNum=' + etcId,
        full: true,
      });
    },
    async handleImport (params) {
      const res = await etcImport(params);
      if (!res.failed) {
        this.$alert(`新增${res.addNum}张卡，更新${res.updateNum}张卡，${res.errorNum}张卡失败！`, {
          confirmButtonText: '确定',
        });
        this.getData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
